import { Component, OnInit, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { AppState } from '@core/app-state/reducers';
import { IdentityUser } from '@core/services/auth/models/application-user.model';
import { AuthService } from '@core/services/auth/services/auth.service';
import { authSelector } from '@core/services/auth/state/authentication.selectors';
import { Store } from '@ngrx/store';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @ViewChild('mobileReportsTrigger') mobileReportsTrigger?: MatMenuTrigger;
  @ViewChild('mobileAdminTrigger') mobileAdminTrigger?: MatMenuTrigger;
  @ViewChild('hamburgerTrigger') mobileMenuTrigger?: MatMenuTrigger;
  data$: Observable<{ user: IdentityUser; isAdmin: boolean; isWarden: boolean; isReader: boolean }>;

  navigation = [
    { link: 'home', label: 'Protocols' },
    // { link: 'statusReport', label: 'Reports' },
  ];

  constructor(private store: Store<AppState>, private authService: AuthService) {
    this.data$ = new Observable();
  }

  toggleMobileSubmenu(trigger: MatMenuTrigger) {
    // Always close the other mobile submenu first (fixes Firefox-iPad ghost overlay)
    this.closeAllMobileSubmenus();

    // Defer to let the previous overlay fully tear down before opening the next
    setTimeout(() => trigger.openMenu(), 0);
  }

  closeAllMobileSubmenus() {
    this.mobileReportsTrigger?.closeMenu();
    this.mobileAdminTrigger?.closeMenu();
  }

  closeAllMenus() {
    this.closeAllMobileSubmenus();
     this.mobileMenuTrigger?.closeMenu();
  }

  ngOnInit(): void {
    const userData$ = this.store.select(authSelector.userData);
    const isAdmin$ = this.store.select(authSelector.isAdmin);
    const isWarden$ = this.store.select(authSelector.isWarden);
    const isReader$ = this.store.select(authSelector.isReader);

    this.data$ = combineLatest([userData$, isAdmin$, isWarden$, isReader$]).pipe(
      map(([userData, admin, warden, reader]) => ({ user: userData, isAdmin: admin, isWarden: warden, isReader: reader })));

    // DEBUG
    // this.data$ = userData$.pipe(map(x => ({ user: x, isAdmin: false, isWarden: false })));
  }

  login(): void {
    this.authService.login();
  }

  logout(): void {
    this.authService.logout();
  }

  copyToClipboard(): void {
    const token = this.authService.getBearerToken();
    document.addEventListener('copy', (e: ClipboardEvent) => {
      e.clipboardData?.setData('text/plain', token);
      e.preventDefault();
      document.removeEventListener('copy', (ev: ClipboardEvent) => {
        ev.preventDefault();
      });
    });
    document.execCommand('copy');
  }
}
